import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import { Button } from '@/components/ui/button'
import { identityPath } from '@/features/identities/identity-path'

/** A persistent, named destination, separate from expanding an entity's properties. */
export function OpenIdentityLink({
  caseId,
  person,
}: {
  caseId: string
  person: { id: string; name: string }
}) {
  const { t } = useTranslation()
  return (
    <Button
      asChild
      variant="link"
      size="xs"
      className="h-auto self-start rounded-sm px-0 py-1.5 text-2xs font-medium leading-5 text-foreground/80 underline decoration-muted-foreground/50 underline-offset-4 hover:text-foreground md:py-0"
    >
      <Link to={identityPath(caseId, person.id)}>
        {t('investigations.entityDetail.openIdentity')}
        <span className="sr-only">: {person.name}</span>
      </Link>
    </Button>
  )
}
